import React from 'react';

/**
 * Wiederverwendbare Input-Komponente mit konsistenten Styles
 */
function AuthInput({ label, type = 'text', value, onChange, placeholder, required = true, isMono = false }) {
  return (
    <div className="mb-6">
      <label className="block text-sm font-bold mb-2">{label}</label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`w-full bg-slate-700/50 border border-purple-500/30 rounded-lg px-4 py-2 text-white placeholder-slate-400 focus:border-purple-500 focus:outline-none transition-colors ${isMono ? 'font-mono text-sm' : ''}`}
      />
    </div>
  );
}

export default AuthInput;
